import { v4 } from "uuid";

export const allElements = {
  advancedElements: [
    {
      id: v4(),
      name: `displayTable-${new Date().getTime()}`,
      type: "displayTable",
      title: "Display Table",
      icon: "../../../../../../../images/layout.svg",
      default: true,
      dataType: "none",
      active: false,
      style: {},
      label: {},
      text: {},
      values: {},
      children: [],
      dataTestId: "displayTable-element",
    },
    {
      id: v4(),
      name: `inputTable-${new Date().getTime()}`,
      type: "inputTable",
      title: "Input Table",
      icon: "../../../../../../../images/layout.svg",
      default: true,
      dataType: "none",
      active: false,
      style: {},
      label: {},
      text: {},
      values: {},
      children: [],
      dataTestId: "inputTable-element",
    },
  ],
  basicElements: [
    {
      id: v4(),
      name: `text-${new Date().getTime()}`,
      type: "text",
      title: "Text",
      icon: "../../../../../../images/icons/type.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "text-element",
    },
    {
      id: v4(),
      name: `heading-${new Date().getTime()}`,
      type: "heading",
      title: "Heading Text",
      icon: "../../../../../../../images/icons/label-text.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "headingText-element",
    },
    {
      id: v4(),
      name: `image-${new Date().getTime()}`,
      type: "image",
      title: "Image",
      icon: "../../../../../../images/icons/image.svg",
      default: true,
      dataType: "none",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "image-element",
    },
    {
      id: v4(),
      name: `pageBreak-${new Date().getTime()}`,
      type: "pageBreak",
      title: "Page Break",
      icon: "../../../../../../images/icons/cut.svg",
      default: true,
      dataType: "none",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "pageBreak-element",
    },
  ],

  inputElements: [
    {
      id: v4(),
      name: `inputText-${new Date().getTime()}`,
      type: "inputText",
      title: "Input Text",
      icon: "../../../../../../../images/icons/type.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "inputText-element",
    },
    {
      id: v4(),
      name: `textArea-${new Date().getTime()}`,
      type: "textArea",
      title: "Text Area",
      icon: "../../../../../../../images/icons/text-field.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "textArea-element",
    },
    {
      id: v4(),
      name: `dropdown-${new Date().getTime()}`,
      type: "dropdown",
      title: "Select dropdown",
      icon: "../../../../../../../images/icons/dropDown.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "dropdown-element",
    },
    {
      id: v4(),
      name: `checkbox-${new Date().getTime()}`,
      title: "Checkbox",
      type: "checkbox",
      icon: "../../../../../../../images/icons/checkmark.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "checkbox-element",
    },
    {
      id: v4(),
      name: `radio-${new Date().getTime()}`,
      title: "Radio",
      type: "radio",
      icon: "../../../../../../../images/icons/radio.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "radio-element",
    },
    /* {
        id: v4(),
        name: `heading-${new Date().getTime()}`,
        type: "heading",
        title: "Label Text",
        icon: "../../../../../../../images/icons/label-text.svg",
        default: true,
        dataType: "text",
        active: false,
        style: {},
        label: {},
        text: {},
        values: [],
        children: [],
      }, */

    {
      id: v4(),
      name: `fileUpload-${new Date().getTime()}`,
      type: "fileUpload",
      title: "File Upload",
      icon: "../../../../../../images/icons/file-upload.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "fileUpload-element",
    },
    {
      id: v4(),
      name: `phoneNumber-${new Date().getTime()}`,
      type: "phoneNumber",
      title: "Phone Number",
      icon: "../../../../../../../images/icons/mobile.svg",
      default: true,
      dataType: "text",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "phoneNumber-element",
    },
    {
      id: v4(),
      name: `dateTime-${new Date().getTime()}`,
      type: "dateTime",
      title: "Date Time",
      icon: "../../../../../../../images/icons/calendar.svg",
      default: true,
      dataType: "datetime",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "dateTime-element",
    },
    {
      id: v4(),
      name: `signature-${new Date().getTime()}`,
      type: "signature",
      title: "Signature",
      icon: "../../../../../../images/icons/edit.svg",
      default: true,
      dataType: "button",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "signature-element",
    },
    {
      id: v4(),
      name: `userPicker-${new Date().getTime()}`,
      type: "userPicker",
      title: "User Picker",
      icon: "../../../../../../images/icons/edit.svg",
      default: true,
      dataType: "users",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
      dataTestId: "userPicker-element",
    },
  ],
  navigationElements: [
    {
      id: v4(),
      name: `header-${new Date().getTime()}`,
      type: "header",
      title: "Header",
      icon: "../../../../../../images/icons/header.svg",
      default: true,
      dataType: "none",
      active: false,
      style: {},
      label: {},
      text: {},
      values: [],
      children: [],
    },
  ],
};
